import {
  AlignmentPlugin,
  BlockFormatPlugin,
  LinkPlugin,
  ListPlugin,
  TableActionMenuPlugin,
  TablePlugin,
  TextColorPlugin,
  TextFormatPlugin,
} from './plugins';
import { TemplatePickerPlugin } from './plugins/TemplatePickerPlugin';
import { TextTemplate } from './textTemplates';

export interface ToolbarPluginProps {
  templates?: TextTemplate[];
  templateValues?: Record<string, string>;
}

export function ToolbarPlugin({
  templates,
  templateValues,
}: ToolbarPluginProps) {
  return (
    <div className="lexical-toolbar">
      <TextFormatPlugin />
      <TextColorPlugin />
      <span className="lexical-toolbar-divider" />
      <BlockFormatPlugin />
      <span className="lexical-toolbar-divider" />
      <ListPlugin />
      <span className="lexical-toolbar-divider" />
      <AlignmentPlugin />
      <span className="lexical-toolbar-divider" />
      <LinkPlugin />
      <span className="lexical-toolbar-divider" />
      <TablePlugin />
      <TableActionMenuPlugin />
      {templates && (
        <>
          <span className="lexical-toolbar-divider" />
          <TemplatePickerPlugin templates={templates} values={templateValues} />
        </>
      )}
    </div>
  );
}
